import React from "react";
import firebase from "firebase/compat/app";
import { candidateLogout } from "../services/AuthService";
import { Link } from "react-router-dom";

const SideBar = () => {
  const handleLogout = () => {
    candidateLogout()
      .then((response) => {
        try {
          if (response.message != null) {
            if (response.data.error_message !== "") {
            }
          } else {
            firebase
              .auth()
              .signOut()
              .then(function () {
                window.localStorage.removeItem("user");
                window.localStorage.removeItem("account");
                window.localStorage.clear();
                sessionStorage.clear();
                window.location.href = "/";
              })
              .catch(function () {});
          }
        } catch (err) {}
      })
      .catch((error) => {
        firebase
          .auth()
          .signOut()
          .then(function () {
            window.localStorage.removeItem("user");
            window.localStorage.removeItem("account");
            window.localStorage.clear();
            sessionStorage.clear();
            window.location.href = "/";
          })
          .catch(function () {});
      });
  };

  return (
    <>
      <div className="nav_wrapper">
        <nav>
          <ul
            className="profile  min-md:fixed z-50 flex flex-nowrap flex-shrink max-md:justify-evenly mb-0 max-md:gap-2 min-md:flex-col min-md:top-16 min-md:h-full min-md:w-40   
                max-md:fixed max-md:bottom-0 max-md:pt-5 max-md:pb-7 max-md:px-2 max-md:w-screen bg-white max-md:drop-shadow-mobile shadow-lg text-xs text-Gray-600 text-center"
          >
            <li className="active min-md:hover:bg-slate-100 min-md:border-blue-200 min-md:border-b">
              <a
                className=" active min-md:p-8 py-8 min-md:h-28 min-md:inline-block "
                href={"/dashboard"}
                to={"/dashboard"}
              >
                <span className="max-md:inline-grid max-md:items-center hover:text-primary-blue active:text-primary-blue focus:text-primary-blue text-Gray-700">
                  <svg
                    className=" pb-1 mb-1 h-6 w-full min-md:h-8"
                    viewBox="0 0 28 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.75 7.75V21.25H2.25V7.75H0.75ZM3.5 24H24.5V22.5H3.5V24ZM27.25 21.25V7.75H25.75V21.25H27.25ZM9 5H3.5V6.5H9V5ZM9.75 5.75V1.35H8.25V5.75H9.75ZM9.6 1.5H18.4V0H9.6V1.5ZM24.5 5H19V6.5H24.5V5ZM19 5H9V6.5H19V5ZM18.25 1.35V5.75H19.75V1.35H18.25ZM18.4 1.5C18.3172 1.5 18.25 1.43284 18.25 1.35H19.75C19.75 0.604415 19.1456 0 18.4 0V1.5ZM27.25 7.75C27.25 6.23122 26.0188 5 24.5 5V6.5C25.1904 6.5 25.75 7.05964 25.75 7.75H27.25ZM24.5 24C26.0188 24 27.25 22.7688 27.25 21.25H25.75C25.75 21.9404 25.1904 22.5 24.5 22.5V24ZM0.75 21.25C0.75 22.7688 1.98122 24 3.5 24V22.5C2.80964 22.5 2.25 21.9404 2.25 21.25H0.75ZM9.75 1.35C9.75 1.43284 9.68284 1.5 9.6 1.5V0C8.85442 0 8.25 0.604416 8.25 1.35H9.75ZM2.25 7.75C2.25 7.05964 2.80964 6.5 3.5 6.5V5C1.98122 5 0.75 6.23122 0.75 7.75H2.25Z"
                      fill="#333333"
                    />
                  </svg>
                  My Jobs
                </span>
              </a>
            </li>
            <li className="active min-md:hover:bg-slate-100 min-md:border-blue-200 min-md:border-b">
              <a
                className=" active min-md:p-8 py-8 min-md:h-28 min-md:inline-block "
                href={"/allJobs"}
                to={"/allJobs"}
              >
                <span className="max-md:inline-grid max-md:items-center hover:text-primary-blue active:text-primary-blue focus:text-primary-blue text-Gray-700">
                <svg width="30" height="30" className=" pb-1 mb-1 h-6 w-full min-md:h-8" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.5 21.25C17.3325 21.25 21.25 17.3325 21.25 12.5C21.25 7.66751 17.3325 3.75 12.5 3.75C7.66751 3.75 3.75 7.66751 3.75 12.5C3.75 17.3325 7.66751 21.25 12.5 21.25Z" stroke="#333333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M18.75 18.75L26.25 26.25" stroke="#333333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
                  Search Jobs
                </span>
              </a>
            </li>
            <li className="min-md:hover:bg-slate-100 min-md:border-blue-200 min-md:border-b">
              <Link href={"/myProfile"} to={"/myProfile/basicInfo"}>
                <span
                  id="nav-toggle"
                  className="t-p-2 min-md:p-8 py-8 max-md:p-0
                            min-md:h-28 min-md:inline-block 
                            group  cursor-pointer max-md:h-2
                            max-md:hover:pt-7 max-md:hover:-mt-7
                            min-md:hover:pr-14 min-md:hover:-mr-6
                            transition-all ease-in-out 
                        "
                >
                  <span className="max-md:inline-grid max-md:items-center hover:text-primary-blue active:text-primary-blue focus:text-primary-blue text-Gray-700">
                    <svg
                      className=" pb-1 mb-1 h-6 w-full min-md:h-8"
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5.25 17C5.25 17.4142 5.58579 17.75 6 17.75C6.41421 17.75 6.75 17.4142 6.75 17H5.25ZM15.25 17C15.25 17.4142 15.5858 17.75 16 17.75C16.4142 17.75 16.75 17.4142 16.75 17H15.25ZM5.25 16V17H6.75V16H5.25ZM16.75 17V16H15.25V17H16.75ZM16.75 16C16.75 12.8244 14.1756 10.25 11 10.25V11.75C13.3472 11.75 15.25 13.6528 15.25 16H16.75ZM6.75 16C6.75 13.6528 8.65279 11.75 11 11.75V10.25C7.82436 10.25 5.25 12.8244 5.25 16H6.75ZM13.25 8C13.25 9.24264 12.2426 10.25 11 10.25V11.75C13.0711 11.75 14.75 10.0711 14.75 8H13.25ZM11 10.25C9.75736 10.25 8.75 9.24264 8.75 8H7.25C7.25 10.0711 8.92893 11.75 11 11.75V10.25ZM8.75 8C8.75 6.75736 9.75736 5.75 11 5.75V4.25C8.92893 4.25 7.25 5.92893 7.25 8H8.75ZM11 5.75C12.2426 5.75 13.25 6.75736 13.25 8H14.75C14.75 5.92893 13.0711 4.25 11 4.25V5.75ZM20.25 11C20.25 16.1086 16.1086 20.25 11 20.25V21.75C16.9371 21.75 21.75 16.9371 21.75 11H20.25ZM11 20.25C5.89137 20.25 1.75 16.1086 1.75 11H0.25C0.25 16.9371 5.06294 21.75 11 21.75V20.25ZM1.75 11C1.75 5.89137 5.89137 1.75 11 1.75V0.25C5.06294 0.25 0.25 5.06294 0.25 11H1.75ZM11 1.75C16.1086 1.75 20.25 5.89137 20.25 11H21.75C21.75 5.06294 16.9371 0.25 11 0.25V1.75Z"
                        fill="#333333"
                      ></path>
                    </svg>
                    My Profile
                  </span>

                  {/* <nav
                  className="hidden group-hover:block  absolute 
                            max-md:-left-0 max-md:bottom-[93px]
                            min-md:left-[160px] min-md:top-0 
                            z-10 max-md:shadow-none  transition ease-in-out text-left"
                >
                  <div className=" bg-primary-white shadow-sm text-primary-dark w-56 text-sm">
                    <ul className="">
                      <Link className="text-dark"  href={"/myProfile"}
                to={"/myProfile/basicInfo"}>
                        {" "}
                        <li className="py-6  px-7 hover:text-primary-blue hover:bg-primary-gray menuItem max-md:py-4 ">
                          <span className="inline-block align-bottom w-5 h-5 mr-2">
                            <svg
                              viewBox="0 0 22 22"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M5.25 17C5.25 17.4142 5.58579 17.75 6 17.75C6.41421 17.75 6.75 17.4142 6.75 17H5.25ZM15.25 17C15.25 17.4142 15.5858 17.75 16 17.75C16.4142 17.75 16.75 17.4142 16.75 17H15.25ZM5.25 16V17H6.75V16H5.25ZM16.75 17V16H15.25V17H16.75ZM16.75 16C16.75 12.8244 14.1756 10.25 11 10.25V11.75C13.3472 11.75 15.25 13.6528 15.25 16H16.75ZM6.75 16C6.75 13.6528 8.65279 11.75 11 11.75V10.25C7.82436 10.25 5.25 12.8244 5.25 16H6.75ZM13.25 8C13.25 9.24264 12.2426 10.25 11 10.25V11.75C13.0711 11.75 14.75 10.0711 14.75 8H13.25ZM11 10.25C9.75736 10.25 8.75 9.24264 8.75 8H7.25C7.25 10.0711 8.92893 11.75 11 11.75V10.25ZM8.75 8C8.75 6.75736 9.75736 5.75 11 5.75V4.25C8.92893 4.25 7.25 5.92893 7.25 8H8.75ZM11 5.75C12.2426 5.75 13.25 6.75736 13.25 8H14.75C14.75 5.92893 13.0711 4.25 11 4.25V5.75ZM20.25 11C20.25 16.1086 16.1086 20.25 11 20.25V21.75C16.9371 21.75 21.75 16.9371 21.75 11H20.25ZM11 20.25C5.89137 20.25 1.75 16.1086 1.75 11H0.25C0.25 16.9371 5.06294 21.75 11 21.75V20.25ZM1.75 11C1.75 5.89137 5.89137 1.75 11 1.75V0.25C5.06294 0.25 0.25 5.06294 0.25 11H1.75ZM11 1.75C16.1086 1.75 20.25 5.89137 20.25 11H21.75C21.75 5.06294 16.9371 0.25 11 0.25V1.75Z"
                                fill="#333333"
                              />
                            </svg>
                          </span>
                          My Basic Info
                        </li>
                      </Link>
                      <Link className="text-dark"  href={"/myProfile"}
                to={"/myProfile/jobPreferences"}>
                        <li className="py-6  px-7 hover:text-primary-blue hover:bg-primary-gray menuItem max-md:py-4 ">
                          <span className="inline-block align-bottom w-5 h-5 mr-2">
                            <svg
                              width="22"
                              height="22"
                              viewBox="0 0 22 22"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9.16663 16.5H19.25"
                                stroke="#333333"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M2.75 16.5H5.5"
                                stroke="#333333"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M5.5 18.3333L5.5 14.6666"
                                stroke="#333333"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M18.3334 11H19.25"
                                stroke="#333333"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M2.75 11H14.6667"
                                stroke="#333333"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M14.6666 12.8333L14.6666 9.16663"
                                stroke="#333333"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M12.8334 5.5H19.25"
                                stroke="#333333"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M2.75 5.5H9.16667"
                                stroke="#333333"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M9.16663 7.33329L9.16663 3.66663"
                                stroke="#333333"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </span>
                          Job Preferences
                        </li>
                      </Link>
                      <Link className="text-dark"  href={"/myProfile"}
                to={"/myProfile/candidateSkills"}>
                        <li className="py-6  px-7 hover:text-primary-blue hover:bg-primary-gray menuItem max-md:py-4 ">
                          <span className="inline-block align-bottom w-5 h-5 mr-2">
                            <svg
                              width="18"
                              height="18"
                              viewBox="0 0 18 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M6.25 17.25H11.75M6.25 17.25V12.6667M6.25 17.25H1.35C1.01863 17.25 0.75 16.9814 0.75 16.65V13.2667C0.75 12.9353 1.01863 12.6667 1.35 12.6667H6.25M11.75 17.25V6.25M11.75 17.25H16.65C16.9814 17.25 17.25 16.9814 17.25 16.65V1.35C17.25 1.01863 16.9814 0.75 16.65 0.75H12.35C12.0186 0.75 11.75 1.01863 11.75 1.35V6.25M11.75 6.25H6.85C6.51863 6.25 6.25 6.51863 6.25 6.85V12.6667"
                                stroke="#333333"
                                strokeWidth="1.5"
                              />
                            </svg>
                          </span>
                          My Skills & Ratings
                          <span className="text-xs text-[#999] inline-block ml-8 mt-1">
                            Skills, Languages & Certifications
                          </span>
                        </li>{" "}
                      </Link>
                      <Link className="text-dark"  href={"/myProfile"}
                to={"/myProfile/jobExperiences"}>
                        <li className="py-6  px-7 hover:text-primary-blue hover:bg-primary-gray menuItem max-md:py-4 ">
                          <span className="inline-block align-bottom w-5 h-5 mr-2">
                            <svg
                              width="22"
                              height="22"
                              viewBox="0 0 22 22"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M6.41663 8.25917L6.42579 8.24898"
                                stroke="#333333"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M10.0834 8.25917L10.0925 8.24898"
                                stroke="#333333"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M6.41663 11.9258L6.42579 11.9156"
                                stroke="#333333"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M10.0834 11.9258L10.0925 11.9156"
                                stroke="#333333"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M6.41663 15.5925L6.42579 15.5824"
                                stroke="#333333"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M10.0834 15.5925L10.0925 15.5824"
                                stroke="#333333"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M13.75 19.25H3.35C3.01863 19.25 2.75 18.9814 2.75 18.65V5.18333C2.75 4.85196 3.01863 4.58333 3.35 4.58333H8.25V3.35C8.25 3.01863 8.51863 2.75 8.85 2.75H13.15C13.4814 2.75 13.75 3.01863 13.75 3.35V8.25M13.75 19.25H18.65C18.9814 19.25 19.25 18.9814 19.25 18.65V8.85C19.25 8.51863 18.9814 8.25 18.65 8.25H13.75M13.75 19.25V15.5833M13.75 8.25V11.9167M13.75 11.9167H15.5833M13.75 11.9167V15.5833M13.75 15.5833H15.5833"
                                stroke="#333333"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </span>
                          Job Experiences
                        </li>
                      </Link>
                      <Link className="text-dark"  href={"/myProfile"}
                to={"/myProfile/careerHighlights"}>
                        <li className="py-6  px-7 hover:text-primary-blue hover:bg-primary-gray menuItem max-md:py-4 ">
                          <span className="inline-block align-bottom w-5 h-5 mr-2">
                            <svg
                              width="22"
                              height="22"
                              viewBox="0 0 22 22"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M13.0825 9.57463L16.5 1.83337M8.53978 9.74628L4.58333 1.83337M11.6981 9.21059L8.09875 1.83337M13.1633 1.83337L12.21 4.12504M5.5 14.6667C5.5 17.7043 7.96243 20.1667 11 20.1667C14.0376 20.1667 16.5 17.7043 16.5 14.6667C16.5 11.6291 14.0376 9.16671 11 9.16671C7.96243 9.16671 5.5 11.6291 5.5 14.6667Z"
                                stroke="#333333"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </span>
                          Career Hightlights
                        </li>
                      </Link>
                      <Link className="text-dark"  href={"/myProfile"}
                to={"/myProfile/CandidateEducation"}>
                        {" "}
                        <li className="py-6  px-7 hover:text-primary-blue hover:bg-primary-gray menuItem max-md:py-4 ">
                          <span className="inline-block align-bottom w-5 h-5 mr-2">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M9.70588 1.94853C9.88971 1.85049 10.1103 1.85049 10.2941 1.94853L19.6691 6.94853C19.8728 7.05715 20 7.26918 20 7.5C20 7.73082 19.8728 7.94285 19.6691 8.05147L10.2941 13.0515C10.1103 13.1495 9.88971 13.1495 9.70588 13.0515L0.330882 8.05147C0.127218 7.94285 0 7.73082 0 7.5C0 7.26918 0.127218 7.05715 0.330882 6.94853L9.70588 1.94853ZM1.95312 7.5L10 11.7917L18.0469 7.5L10 3.20833L1.95312 7.5Z"
                                fill="#333333"
                              />
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M9.4485 7.20585C9.61094 6.90128 9.98952 6.78606 10.2941 6.9485L14.9816 9.4485C15.1853 9.55712 15.3125 9.76915 15.3125 9.99997V18.75C15.3125 19.0951 15.0326 19.375 14.6875 19.375C14.3423 19.375 14.0625 19.0951 14.0625 18.75V10.375L9.70585 8.05144C9.40128 7.889 9.28606 7.51042 9.4485 7.20585Z"
                                fill="#333333"
                              />
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M2.81251 8.03909C3.15768 8.03909 3.43751 8.31891 3.43751 8.66409V12.9219L3.43888 12.9237C3.90238 13.5463 5.9575 15.9375 10 15.9375C14.0425 15.9375 16.0977 13.5463 16.5612 12.9237L16.5625 12.9219V8.66409C16.5625 8.31891 16.8423 8.03909 17.1875 8.03909C17.5327 8.03909 17.8125 8.31891 17.8125 8.66409V12.9297L17.8125 12.9324C17.8114 13.1998 17.7234 13.4596 17.5619 13.6727C16.9752 14.4598 14.593 17.1875 10 17.1875C5.40698 17.1875 3.02482 14.4598 2.43812 13.6727C2.27661 13.4596 2.18864 13.1998 2.18751 12.9324L2.1875 12.9297L2.18751 8.66409C2.18751 8.31891 2.46733 8.03909 2.81251 8.03909Z"
                                fill="#333333"
                              />
                            </svg>
                          </span>
                          Education
                        </li>
                      </Link>
                      <Link className="text-dark"  href={"/myProfile"}
                        to={"/myProfile/Resume"}>
                        <li className="py-6  px-7 hover:text-primary-blue hover:bg-primary-gray menuItem max-md:py-4 ">
                          <span className="inline-block align-bottom w-5 h-5 mr-2">
                            <svg
                              width="22"
                              height="22"
                              viewBox="0 0 22 22"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M3.66663 19.5667V2.43337C3.66663 2.102 3.93526 1.83337 4.26663 1.83337H14.8764C15.0356 1.83337 15.1882 1.89659 15.3007 2.00911L18.1576 4.86597C18.2701 4.97849 18.3333 5.13111 18.3333 5.29024V19.5667C18.3333 19.8981 18.0647 20.1667 17.7333 20.1667H4.26663C3.93526 20.1667 3.66663 19.8981 3.66663 19.5667Z"
                                stroke="#333333"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M14.6666 4.90004V2.15746C14.6666 1.97847 14.8117 1.83337 14.9907 1.83337C15.0767 1.83337 15.1591 1.86752 15.2199 1.9283L18.2384 4.94678C18.2991 5.00756 18.3333 5.09 18.3333 5.17595C18.3333 5.35494 18.1882 5.50004 18.0092 5.50004H15.2666C14.9353 5.50004 14.6666 5.23141 14.6666 4.90004Z"
                                fill="#333333"
                                stroke="#333333"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M7.33337 9.16663L14.6667 9.16663"
                                stroke="#333333"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M7.33337 16.5L14.6667 16.5"
                                stroke="#333333"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M7.33337 12.8334L11 12.8334"
                                stroke="#333333"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </span>
                          Resume
                        </li>
                      </Link>
                      
                    </ul>
                  </div>
                </nav> */}
                </span>
              </Link>
            </li>

            <li className="min-md:hover:bg-slate-100 min-md:border-blue-200 min-md:border-b">
              <Link
                className="t-p-2 min-md:p-8 py-8 min-md:h-28 min-md:inline-block "
                href={"/SmartResume"}
                to={"/SmartResume"}
              >
                <span className="max-md:inline-grid max-md:items-center hover:text-primary-blue active:text-primary-blue focus:text-primary-blue text-Gray-700">
                  <svg
                    className=" pb-1 mb-1 h-6 w-full min-md:h-8"
                    viewBox="0 0 23 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M21 14V6.12353C21 5.9644 20.9368 5.81179 20.8243 5.69926L16.8007 1.67574C16.6882 1.56321 16.5356 1.5 16.3765 1.5H1.6C1.26863 1.5 1 1.76863 1 2.1V25.9C1 26.2314 1.26863 26.5 1.6 26.5H9.75"
                      stroke="#333333"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M6 11.5H16M6 6.5H11M6 16.5H9.75"
                      stroke="#333333"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M16 5.9V1.94194C16 1.69786 16.1979 1.5 16.4419 1.5C16.5592 1.5 16.6716 1.54656 16.7544 1.62944L20.8706 5.74556C20.9534 5.82844 21 5.94085 21 6.05806C21 6.30214 20.8021 6.5 20.5581 6.5H16.6C16.2686 6.5 16 6.23137 16 5.9Z"
                      fill="#333333"
                      stroke="#333333"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M16.382 20.3916L17.5184 17.982C17.6643 17.6727 18.0857 17.6727 18.2316 17.982L19.368 20.3916L21.9094 20.7803C22.2355 20.8302 22.3654 21.2497 22.1294 21.4904L20.2908 23.3646L20.7247 26.0125C20.7804 26.3525 20.4394 26.6118 20.1476 26.4512L17.875 25.2004L15.6024 26.4512C15.3106 26.6118 14.9696 26.3525 15.0253 26.0125L15.4592 23.3646L13.6206 21.4904C13.3846 21.2497 13.5145 20.8302 13.8406 20.7803L16.382 20.3916Z"
                      stroke="#333333"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  Smart Resume
                </span>
              </Link>
            </li>
            <li className="min-md:hover:bg-slate-100 min-md:border-blue-200 min-md:border-b">
              <a
                className="t-p-2 min-md:p-8 py-8 min-md:h-28 min-md:inline-block "
                href={"/peerrating"}
                to={"/peerrating"}
              >
                <span className="max-md:inline-grid max-md:items-center hover:text-primary-blue active:text-primary-blue focus:text-primary-blue text-Gray-700">
                  <svg
                    className=" pb-1 mb-1 h-6 w-full min-md:h-8"
                    viewBox="0 0 28 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.73422 8.29496L12.9811 1.7547C13.3979 0.9151 14.6021 0.9151 15.0189 1.7547L18.2658 8.29496L25.5268 9.35021C26.4585 9.4856 26.8298 10.6242 26.1553 11.2774L20.9022 16.3647L22.1419 23.5518C22.3011 24.4747 21.3267 25.1785 20.4932 24.7427L14 21.3475L7.50684 24.7427C6.67325 25.1785 5.69886 24.4747 5.85807 23.5518L7.09782 16.3647L1.84469 11.2774C1.17022 10.6242 1.54152 9.4856 2.47315 9.35021L9.73422 8.29496Z"
                      stroke="black"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  My Peers
                </span>
              </a>
            </li>
            {/* <li className="min-md:hover:bg-slate-100 min-md:border-blue-200 min-md:border-b">
                    <Link className="t-p-2 min-md:p-8 py-8 min-md:h-28 min-md:inline-block " href={"/notifications"}  to={"/notifications"}>
                        <span className="max-md:inline-grid max-md:items-center hover:text-primary-blue active:text-primary-blue focus:text-primary-blue text-Gray-700">
                            <svg className=" pb-1 mb-1 h-6 w-full min-md:h-8" viewBox="0 0 24 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M19.5 9.5C19.5 7.37827 18.7098 5.34344 17.3033 3.84315C15.8968 2.34285 13.9891 1.5 12 1.5C10.0109 1.5 8.10322 2.34285 6.6967 3.84315C5.29018 5.34344 4.5 7.37827 4.5 9.5C4.5 18.8333 0.75 21.5 0.75 21.5H23.25C23.25 21.5 19.5 18.8333 19.5 9.5Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M14.1624 25.25C13.9426 25.6288 13.6272 25.9433 13.2477 26.1619C12.8682 26.3805 12.4379 26.4956 11.9999 26.4956C11.5619 26.4956 11.1316 26.3805 10.7521 26.1619C10.3726 25.9433 10.0572 25.6288 9.8374 25.25" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                            Notifications</span>
                    </a>
                </li> */}
            {/* <li className="min-md:hover:bg-slate-100 min-md:border-blue-200 min-md:border-b">
              <span
                className="t-p-2 min-md:p-8 py-8 min-md:h-28 min-md:inline-block temanics-link-pointer"
                href="#"
                onClick={handleLogout}
              >
                <span className="max-md:inline-grid max-md:items-center hover:text-primary-blue active:text-primary-blue focus:text-primary-blue text-Gray-700">
                  <svg
                    className=" pb-1 mb-1 h-6 w-full min-md:h-8"
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M14.467 6.90449C14.7355 6.636 15.1708 6.636 15.4393 6.90449L19.0486 10.5139C19.3171 10.7823 19.3171 11.2177 19.0486 11.4861L15.4393 15.0955C15.1708 15.364 14.7355 15.364 14.467 15.0955C14.1985 14.827 14.1985 14.3917 14.467 14.1232L17.5902 11L14.467 7.87676C14.1985 7.60828 14.1985 7.17297 14.467 6.90449Z"
                      fill="black"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M8.25 11C8.25 10.6203 8.5578 10.3125 8.9375 10.3125H18.5625C18.9422 10.3125 19.25 10.6203 19.25 11C19.25 11.3797 18.9422 11.6875 18.5625 11.6875H8.9375C8.5578 11.6875 8.25 11.3797 8.25 11Z"
                      fill="black"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M3.15273 3.15273C3.41059 2.89487 3.76033 2.75 4.125 2.75H8.9375C9.3172 2.75 9.625 3.0578 9.625 3.4375C9.625 3.8172 9.3172 4.125 8.9375 4.125L4.125 4.125L4.125 17.875H8.9375C9.3172 17.875 9.625 18.1828 9.625 18.5625C9.625 18.9422 9.3172 19.25 8.9375 19.25H4.125C3.76033 19.25 3.41059 19.1051 3.15273 18.8473C2.89487 18.5894 2.75 18.2397 2.75 17.875V4.125C2.75 3.76033 2.89487 3.41059 3.15273 3.15273Z"
                      fill="black"
                    />
                  </svg>
                  Logout
                </span>
              </span>
            </li> */}
          </ul>
        </nav>
      </div>
    </>
  );
};

export default SideBar;
